import {ServiceOrderEvaluationStatus} from "./ServiceOrderEvaluationStatus";

export const ServiceOrderEvaluationStatusNames: Record<ServiceOrderEvaluationStatus, string> = {
  [ServiceOrderEvaluationStatus.IN_PROGRESS]: "En Progreso",
  [ServiceOrderEvaluationStatus.COMPLETED]: "Completada",
};
